/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CorporateStructureLink', 'model/IntegrationPipedriveSettingsPipelineStagePaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CorporateStructureLink'), require('./IntegrationPipedriveSettingsPipelineStagePaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.IntegrationPipedriveSettingsPipelineReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CorporateStructureLink, root.ForStractionServiceApi.IntegrationPipedriveSettingsPipelineStagePaginationSlice);
  }
}(this, function(ApiClient, CorporateStructureLink, IntegrationPipedriveSettingsPipelineStagePaginationSlice) {
  'use strict';




  /**
   * The IntegrationPipedriveSettingsPipelineReport model module.
   * @module model/IntegrationPipedriveSettingsPipelineReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>IntegrationPipedriveSettingsPipelineReport</code>.
   * @alias module:model/IntegrationPipedriveSettingsPipelineReport
   * @class
   */
  var exports = function() {
    var _this = this;















  };

  /**
   * Constructs a <code>IntegrationPipedriveSettingsPipelineReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationPipedriveSettingsPipelineReport} obj Optional instance to populate.
   * @return {module:model/IntegrationPipedriveSettingsPipelineReport} The populated <code>IntegrationPipedriveSettingsPipelineReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('PipelineStages')) {
        obj['PipelineStages'] = IntegrationPipedriveSettingsPipelineStagePaginationSlice.constructFromObject(data['PipelineStages']);
      }
      if (data.hasOwnProperty('SettingsID')) {
        obj['SettingsID'] = ApiClient.convertToType(data['SettingsID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('ExternalPipelineID')) {
        obj['ExternalPipelineID'] = ApiClient.convertToType(data['ExternalPipelineID'], 'Integer');
      }
      if (data.hasOwnProperty('ImportLossDealCount')) {
        obj['ImportLossDealCount'] = ApiClient.convertToType(data['ImportLossDealCount'], 'Boolean');
      }
      if (data.hasOwnProperty('ImportLossDealCountIndicatorID')) {
        obj['ImportLossDealCountIndicatorID'] = ApiClient.convertToType(data['ImportLossDealCountIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('ImportLossDealSum')) {
        obj['ImportLossDealSum'] = ApiClient.convertToType(data['ImportLossDealSum'], 'Boolean');
      }
      if (data.hasOwnProperty('ImportLossDealSumIndicatorID')) {
        obj['ImportLossDealSumIndicatorID'] = ApiClient.convertToType(data['ImportLossDealSumIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('ImportWinDealCount')) {
        obj['ImportWinDealCount'] = ApiClient.convertToType(data['ImportWinDealCount'], 'Boolean');
      }
      if (data.hasOwnProperty('ImportWinDealCountIndicatorID')) {
        obj['ImportWinDealCountIndicatorID'] = ApiClient.convertToType(data['ImportWinDealCountIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('ImportWinDealSum')) {
        obj['ImportWinDealSum'] = ApiClient.convertToType(data['ImportWinDealSum'], 'Boolean');
      }
      if (data.hasOwnProperty('ImportWinDealSumIndicatorID')) {
        obj['ImportWinDealSumIndicatorID'] = ApiClient.convertToType(data['ImportWinDealSumIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('CorporateStructureLink')) {
        obj['CorporateStructureLink'] = CorporateStructureLink.constructFromObject(data['CorporateStructureLink']);
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {module:model/IntegrationPipedriveSettingsPipelineStagePaginationSlice} PipelineStages
   */
  exports.prototype['PipelineStages'] = undefined;
  /**
   * @member {Integer} SettingsID
   * @default 0
   */
  exports.prototype['SettingsID'] = 0;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} ExternalPipelineID
   */
  exports.prototype['ExternalPipelineID'] = undefined;
  /**
   * @member {Boolean} ImportLossDealCount
   * @default false
   */
  exports.prototype['ImportLossDealCount'] = false;
  /**
   * @member {Integer} ImportLossDealCountIndicatorID
   */
  exports.prototype['ImportLossDealCountIndicatorID'] = undefined;
  /**
   * @member {Boolean} ImportLossDealSum
   * @default false
   */
  exports.prototype['ImportLossDealSum'] = false;
  /**
   * @member {Integer} ImportLossDealSumIndicatorID
   */
  exports.prototype['ImportLossDealSumIndicatorID'] = undefined;
  /**
   * @member {Boolean} ImportWinDealCount
   * @default false
   */
  exports.prototype['ImportWinDealCount'] = false;
  /**
   * @member {Integer} ImportWinDealCountIndicatorID
   */
  exports.prototype['ImportWinDealCountIndicatorID'] = undefined;
  /**
   * @member {Boolean} ImportWinDealSum
   * @default false
   */
  exports.prototype['ImportWinDealSum'] = false;
  /**
   * @member {Integer} ImportWinDealSumIndicatorID
   */
  exports.prototype['ImportWinDealSumIndicatorID'] = undefined;
  /**
   * @member {module:model/CorporateStructureLink} CorporateStructureLink
   */
  exports.prototype['CorporateStructureLink'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


